/** Türkçe çeviri — en.ts ile aynı düz anahtar yapısı */
const tr = {
  unique_death_history: "Ölüm kayıtları",
  reg_events: "Etkinlikler",
  reg_details: "Açıklama ve ödüller",
  reg_details_pending: "Ayrıntılar yakında duyurulacak.",
  reg_open: "Açık",
  reg_closed: "Kapalı",
  reg_joined: "Kayıtlı",
  reg_equalized: "Eşitlenmiş",
  reg_standard: "Standart",
  reg_cancel_registration: "Kaydı iptal et",
  reg_joined_hint: "Bu etkinliğe kayıtlısınız.",
  reg_open_hint: "Kayıtlar açık. Katılmak için kaydolun.",
  reg_closed_hint: "Kayıtlar kapalı.",
  reg_translating: "Çevriliyor…",
  reg_translation_error: "Çeviri yapılamadı. Özgün metin gösteriliyor.",
  reg_retry: "Yeniden dene",

  battle_pass: 'Savaş Pası',
  menu_main: 'Ana menü',
  menu_tools: 'Araçlar',
  menu_open: 'Menüyü aç',
  menu_close: 'Menüyü kapat',
  menu_home: 'Ana sayfaya dön',
  guide: 'Rehber',
  daily_login: 'Günlük Giriş',
  spin_title: 'Çark',
  special_offer: 'Özel Teklif',
  auction_system: 'Açık Artırma Sistemi',
  title_manager: 'Özelleştirme',
  ranking: 'Sıralama',
  unique: 'Eşsiz',
  job_system: 'İş Sistemi',
  vip_system: 'VIP',
  donation: 'Bağış',
  surveys: 'Anketler',
  settings: 'Ayarlar',
  messages: 'Mesajlar',
  unique_status_title: 'Mevcut Durum',
  unique_logs_title: 'Geçmiş Kaydı',
  unique_table_name: 'Unique',
  unique_table_character: 'Karakter',
  unique_table_status: 'Durum',
  unique_table_event: 'Etkinlik',
  unique_table_map: 'Harita',
  unique_table_time: 'Zaman',
  unique_status_alive: 'Hayatta',
  unique_status_dead: 'Ölü',
  unique_event_spawn: 'Doğdu',
  unique_event_death: 'Öldürüldü',
  unique_refresh: 'Yenile',
  unique_sort_alive_first: 'Sırala: önce hayatta',
  unique_sort_dead_first: 'Sırala: önce ölü',
  unique_deaths_tooltip_title: 'Son 5 öldürme',
  unique_deaths_empty: 'Kayıtlı öldürme yok',
  unique_load_error: 'Unique geçmişi yüklenemedi.',
  unique_no_data: 'Veri bulunamadı.',
  unique_logs_empty: 'Henüz geçmiş etkinlik yok.',
  schedule: 'Takvim',
  sched_no_events: 'Planlanmış etkinlik yok.',
  sched_running: 'ÇALIŞIYOR',
  sched_load_error: 'Takvim yüklenemedi. Daha sonra tekrar deneyin.',
  reg_register: 'Kayıt Ol',
  reg_remove_register: 'Kaydı Kaldır',
  reg_processing: 'İşleniyor...',
  reg_registered_success: 'Etkinliğe başarıyla kaydoldunuz',
  reg_unregistered_success: 'Etkinlikten başarıyla kaydınızı kaldırdınız',
  reg_no_events: 'Mevcut etkinlik yok.',
  reg_load_error: 'Etkinlikler yüklenemedi. Daha sonra tekrar deneyin.',
  reg_error_invalid_event: 'Geçersiz etkinlik',
  reg_error_not_logged_in: 'Etkinliklere kaydolmak için giriş yapmalısınız',
  reg_error_not_available: 'Etkinlik kayıt için mevcut değil',
  reg_error_already_registered: 'Etkinliğe kayıt hatası. Zaten kayıtlı olabilirsiniz.',
  reg_error_unregister: 'Etkinlikten kayıt kaldırma hatası',
  reg_error_processing: 'İstek işlenirken hata',
  reg_error_connection: 'Bağlantı hatası. Lütfen tekrar deneyin.',
  reg_modal_title: 'Equalized System',
  reg_weapons: 'Silahlar (1 Seçin)',
  reg_buffs: 'Bufflar (1 Seçin)',
  reg_essence: 'Essence (Her zaman aktif)',
  reg_force: 'Force (Her zaman aktif)',
  reg_btn_register: 'Kayıt Ol',
  reg_btn_cancel: 'İptal',
  register: 'Kayıt Ol',
  r_ia: 'R-AI',
  chat_welcome_message: 'Merhaba! 👋 Ben <strong>R-AI</strong>, Silkroad Origins için yapay zeka asistanınızım.',
  chat_welcome_question: 'Bugün size nasıl yardımcı olabilirim?',
  chat_input_placeholder: 'Mesajınızı yazın...',
  chat_send_button: 'Gönder',
  chat_send_title: 'Mesaj gönder',
  chat_char_count: '{current} / {max}',
  chat_load_error: 'Sohbet geçmişi yüklenemedi. Daha sonra tekrar deneyin.',
  chat_error_connection: 'Bağlantı hatası. Lütfen tekrar deneyin.',
  drop_log: 'Düşme Kaydı',
  log_table_item: 'Eşya',
  log_table_character: 'Karakter',
  log_table_monster: 'Canavar',
  log_table_map: 'Harita',
  log_table_date: 'Tarih',
  log_table_ago: 'Önce',
  log_search_placeholder: 'Ara...',
  log_time_seconds: 'sn',
  log_time_minutes: 'dk',
  log_time_hours: 's',
  log_time_days: 'g',
  log_filter_race: 'Irk',
  log_filter_race_chinese: 'Chinese',
  log_filter_race_euro: 'Avrupalı',
  log_filter_type: 'Tür',
  log_filter_time_all: 'Tümü',
  log_filter_time_today: 'Bugün',
  log_filter_time_week: 'Bu Hafta',
  log_filter_time_month: 'Bu Ay',
  log_filter_apply: 'Uygula',
  log_filter_reset: 'Sıfırla',
  log_load_error: 'Düşme kaydı yüklenemedi. Daha sonra tekrar deneyin.',
  log_no_results: 'Filtrelenmiş düşme yok.',
  log_modal_i_need_it: 'Buna İhtiyacım Var',
  log_modal_sending: 'Gönderiliyor...',
  log_modal_sent: 'Gönderildi',
  log_modal_error: 'Hata',
  log_modal_connection_error: 'Bağlantı hatası',
  log_modal_message_template: 'Merhaba, düşürdüğünüz {item} ile ilgileniyorum. Ne kadar istiyorsunuz?',
  log_chat_button_title: 'Sohbet ile iletişim kur',
  log_chat_self_error: 'Kendinize mesaj gönderemezsiniz',
  languages: 'Diller',
  server_time: 'Sunucu Saati',
  loading_data: 'Veriler yükleniyor...',
  auth_loading: 'Kimlik doğrulanıyor...',
  auth_error: 'Kimlik doğrulanamadı. Oyundan yeniden açın.',
  bp_duration: 'Süre: {start} - {end} ({remaining} kaldı)',
  bp_level: 'Seviye',
  bp_buy_pass: 'Pas Satın Al',
  bp_premium_active: 'Premium pas aktif',
  bp_premium_reward: 'Premium Ödül',
  bp_max_level: 'Maksimum Seviye: {level}',
  bp_no_active: 'Aktif savaş pası yok',
  bp_reward_success: 'Ödül başarıyla talep edildi!',
  bp_claim_error: 'Ödül talep edilemedi. Daha sonra tekrar deneyin.',
  bp_exp_info_title: 'Battle Pass Deneyimi',
  bp_exp_tower_defense_victory: 'Kule Savunması: Zafer: 45 puan | Yenilgi: 5 puan',
  bp_exp_hell_prison_victory: 'Cehennem Hapishanesi: Zafer: 50 puan | Yenilgi: 10 puan',
  bp_exp_witch_hunt_victory: 'Cadı Avı: Zafer: 50 puan | Yenilgi: 10 puan',
  bp_exp_survival: 'Hayatta Kalma: 1. Sıra: 30 Puan | 2. Sıra: 15 puan | 3. Sıra: 5 puan',
  bp_exp_last_man_standing: 'Son Adam Ayakta: Zafer: 95 puan',
  bp_exp_madness: 'Çılgınlık: 1. Sıra: 30 Puan | 2. Sıra: 15 puan | 3. Sıra: 5 puan',
  bp_exp_garden_job_victory: 'Bahçe (İş): Zafer: 50 puan | Yenilgi: 10 puan',
  bp_exp_capture_flag_victory: 'Bayrağı Yakala: Zafer: 50 puan | Yenilgi: 10 puan',
  bp_exp_battle_arena_victory: 'Savaş Arenası: Zafer: 50 puan | Yenilgi: 10 puan',
  bp_exp_league_map_victory: 'Lig Haritası: Zafer: 55 puan | Yenilgi: 10 puan',
  bp_exp_medusa_victory: 'Medusa: Zafer: 100 puan | Yenilgi: 20 puan',
  bp_exp_roc_victory: 'Roc: Zafer: 100 puan | Yenilgi: 20 puan',
  bp_exp_normal_uniques_victory: 'Normal Uniques: Zafer: 5 puan | Yenilgi: 3 puan',
  bp_exp_arabian_uniques_victory: 'Arap Uniques: Zafer: 7 puan | Yenilgi: 5 puan',
  bp_exp_legendary_uniques_victory: 'Efsanevi Uniques: Zafer: 10 puan | Yenilgi: 7 puan',
  bp_exp_job_kills: 'İş Öldürmeleri: Öldürme başına 2 puan',
  bp_exp_job_delivery: 'İş Teslimatı: Teslimat başına 15 puan',
  bp_exp_global_chat: 'Global Sohbet Kullanımı: Kullanım başına 2 puan',
  bp_exp_summary:
    'BP XP kazanın: Kule Savunması, Cehennem Hapishanesi, Cadı Avı, Hayatta Kalma, Çılgınlık, Bahçe İşi, Bayrağı Yakala, Savaş Arenası, Lig Haritası, Medusa, Roc, Uniques, İş öldürme/teslimat ve Global Sohbet.',
  silk_confirm_cost: 'Maliyet: {amount} Silk',
  silk_confirm_balance: 'Bakiyeniz: {amount} Silk',
  silk_confirm_after: 'Satın alma sonrası bakiye: {amount} Silk',
  silk_confirm_not_enough: 'Bu satın alma için yeterli Silk\'iniz yok.',
  silk_confirm_cancel: 'İptal',
  silk_confirm_confirm: 'Onayla',
  bp_premium_confirm_title: 'Premium Pas Satın Al',
  bp_premium_confirm_msg: 'Bu sezon için tüm premium ödüllerin kilidini açın.',
  bp_levelup_confirm_title: 'Seviye Atla',
  bp_levelup_confirm_msg: 'Anında bir Battle Pass seviyesi kazanın.',
  silk_confirm_price_label: 'Fiyat',
  silk_confirm_your_silk: 'Silk\'iniz',
  silk_confirm_checking: 'Kontrol ediliyor...',
  silk_confirm_unavailable: 'Kullanılamaz',
  silk_confirm_retry_later: 'Daha Sonra Tekrar Deneyin',
  silk_confirm_not_enough_short: 'Yeterli Silk Yok',
  silk_confirm_processing: 'İşleniyor',
  silk_confirm_processing_msg: 'Satın alma işleminiz yapılıyor...',
  silk_confirm_success: 'Başarılı',
  silk_confirm_failed: 'Başarısız',
  silk_confirm_wait: 'Lütfen Bekleyin',
  silk_confirm_close: 'Kapat',
  cal_schedule_label: 'Giriş Takvimi: {start} - {end}',
  cal_remaining_label: '({remaining} kaldı)',
  cal_checked_in_status: '{total} günden {checked} gün giriş yapıldı ({missed} gün kaçırıldı)',
  cal_day_label: 'Gün {day}',
  cal_checkin_available: 'Şimdi giriş yapabilirsiniz!',
  cal_next_checkin: 'Sonraki giriş: {hours}s {minutes}d',
  cal_claim_error: 'İşlem tamamlanamadı. Daha sonra tekrar deneyin.',
  cal_no_campaign: 'Aktif kampanya yok',
  spin_daily_spins: '{max} Günlük Çevirme ({used}/{max})',
  spin_recent_rewards: 'Son 5 Ödül',
  spin_congratulations: 'Tebrikler!',
  spin_probability: 'Olasılık:',
  spin_daily_reached_tooltip: 'Günlük limit doldu. Tekrar kullanmak için Silk ile satın alın.',
  spin_reset_confirm_title: 'Sıfırlamayı Onayla',
  spin_reset_confirm_message: 'Çevirmeleri sıfırlamak istediğinizden emin misiniz?',
  spin_reset_confirm_silk: '{amount} silk',
  spin_reset_confirm_cancel: 'İptal',
  spin_reset_confirm_confirm: 'Onayla',
  spin_reset_success: 'Çevirmeler başarıyla sıfırlandı!',
  spin_reset_error: 'Çevirmeler sıfırlanamadı.',
  spin_error_spin: 'Çark döndürülemedi.',
  spin_error_winner: 'Kazanan eşya bulunamadı.',
  spin_error_connection: 'Sunucu ile bağlantı hatası.',
  so_title: 'Özel Teklif',
  so_recommended: 'Önerilen',
  so_offer_ends_in: 'Teklif bitiyor',
  so_buy: 'SATIN AL',
  so_available: 'Mevcut',
  so_sold_out: 'Tükendi',
  so_processing: 'İşleniyor...',
  so_purchase_success: 'Satın alma başarılı!',
  so_purchase_error: 'Satın alma hatası',
  so_network_error: 'Ağ hatası',
  so_confirm_title: 'Satın Almayı Onayla',
  so_confirm_message: '{name} satın alınsın mı?',
  so_no_offers: 'Aktif teklif yok',
  auc_time_left: 'Kalan süre',
  auc_bid_concluded: 'Teklif Tamamlandı',
  auc_winner: 'Kazanan',
  auc_auction_starting_soon: 'Müzayede yakında başlayacak',
  auc_enter_bid: 'Teklifinizi girin',
  auc_bid_now: 'Şimdi Teklif Ver',
  auc_be_first_to_bid: 'İlk teklif veren olun',
  auc_current_bid: 'Mevcut Teklif',
  auc_by: 'tarafından',
  auc_latest_bids: 'Son Teklifler',
  auc_auction_ended: 'Müzayede sona erdi. Kazananı tebrik ederiz!',
  auc_wait_next_auction: 'Lütfen bir sonraki müzayedenin başlamasını bekleyin.',
  auc_item_rewards: 'Eşya Ödülleri',
  auc_no_rewards: 'Ödül mevcut değil',
  auc_bid_success: 'Teklif başarıyla verildi!',
  auc_bid_error: 'Teklif verme hatası.',
  auc_invalid_bid: 'Geçerli bir teklif miktarı girin.',
  tm_tab_name: "Name",
  tm_name_colors: "Kayıtlı isim renkleri",
  tm_name_apply: "Rengi uygula",
  tm_name_select: "Renk seç",
  tm_name_empty: "Henüz kayıtlı renk yok.",
  tm_name_reuse: "Her renk 999 Silk. Satın alınan renkler ücretsiz tekrar kullanılabilir. Değişiklikler arasında 30 saniye bekle.",
  tm_name_buy: "İsim rengi satın al",
  tm_name_purchased: "İsim rengi satın alındı.",
  tm_name_applied: "İsim rengi uygulandı.",
  tm_name_owned: "Zaten sende",
  tm_name_error: "Renk işlenemedi.",
  tm_cooldown: "Yeni değişiklik için {seconds} saniye bekle.",
  tm_tab_title: 'Başlık',
  tm_tab_icon: 'Simge',
  tm_tab_tag: 'Etiket',
  tm_title_column: 'Başlık',
  tm_tag_column: 'Etiket',
  tm_actions_column: 'İşlemler',
  tm_enter_title: 'Başlık metnini girin...',
  tm_enter_tag: 'Etiket metnini girin...',
  tm_test: 'Test Et',
  tm_edit: 'Düzenle',
  tm_edit_title_modal_title: 'Başlığı Düzenle',
  tm_price_edit: 'Düzenleme Fiyatı',
  tm_error_editing_title: 'Başlık düzenlenirken hata.',
  tm_title_edited: 'Başlık başarıyla güncellendi.',
  tm_buy: 'Satın Al',
  tm_total_pay: 'Ödenecek toplam',
  tm_color_optional: 'Özel renk (isteğe bağlı)',
  tm_edit_separate: 'Mevcut unvanı düzenle (ayrı)',
  tm_price_title: 'Başlık Fiyatı',
  tm_price_color: 'Renk Fiyatı',
  tm_price_tag: 'Etiket Fiyatı',
  tm_price_icon_label: '{amount} Silk',
  tm_apply_title: 'Başlığı Uygula',
  tm_remove_title: 'Başlığı Kaldır',
  tm_apply_tag: 'Etiketi Uygula',
  tm_remove_tag: 'Etiketi Kaldır',
  tm_no_titles: 'Kayıtlı başlık yok.',
  tm_no_tags: 'Kayıtlı etiket yok.',
  tm_no_icons: 'Simge bulunamadı.',
  tm_icon_search: 'Simge ara...',
  tm_icon_left: 'Sol Simge',
  tm_icon_right: 'Sağ Simge',
  tm_buy_title_modal_title: 'Başlık Satın Almayı Onayla',
  tm_buy_tag_modal_title: 'Etiket Satın Almayı Onayla',
  tm_buy_icon_modal_title: 'Simge Satın Almayı Onayla',
  tm_buy_title_label: 'Başlık:',
  tm_buy_tag_label: 'Etiket:',
  tm_buy_icon_label: 'Simge:',
  tm_buy_price_label: 'Fiyat:',
  tm_buy_balance_label: 'Bakiyeniz:',
  tm_buy_includes: 'İçerir:',
  tm_buy_includes_title_color: 'Başlık + Özel Renk',
  tm_buy_not_enough: '⚠ Yeterli Silk\'iniz yok.',
  tm_buy_needs_more: '{amount} daha fazla Silk\'e ihtiyacınız var.',
  tm_buy_confirm: 'Satın Almayı Onayla',
  tm_buy_cancel: 'İptal',
  tm_error_testing_title: 'Başlık test edilirken hata.',
  tm_error_buying_title: 'Başlık satın alınırken hata.',
  tm_error_buying_tag: 'Etiket satın alınırken hata.',
  tm_error_buying_icon: 'Simge satın alınırken hata.',
  tm_error_applying_icon: 'Simge uygulanırken hata.',
  tm_error_getting_balance: 'Silk bakiyesi alınırken hata.',
  tm_error_applying_title: 'Başlık uygulanırken hata.',
  tm_error_applying_tag: 'Etiket uygulanırken hata.',
  tm_error_removing_title: 'Başlık kaldırılırken hata.',
  tm_error_removing_tag: 'Etiket kaldırılırken hata.',
  tm_processing: 'İşleniyor...',
  tm_already_have_title: 'Bu başlığa zaten sahipsiniz.',
  tm_already_have_tag: 'Bu etikete zaten sahipsiniz.',
  tm_already_have_icon: 'Bu simgeye zaten sahipsiniz.',
  tm_not_enough_silk: 'Yeterli Silk yok.',
  tm_title_applied: 'Başlık başarıyla uygulandı.',
  tm_title_purchased: 'Başlık satın alındı! Yeni başlığınızın tadını çıkarın.',
  tm_tag_applied: 'Etiket başarıyla uygulandı.',
  tm_icon_applied: 'Simge başarıyla uygulandı.',
  tm_title_removed: 'Başlık başarıyla devre dışı bırakıldı.',
  tm_tag_removed: 'Etiket başarıyla kaldırıldı.',
  tm_icon_purchased: 'Simge başarıyla satın alındı.',
  tm_test_applied: 'Başlık önizlemesi uygulandı (geçici).',
  ranking_search_placeholder: 'Oyuncu ara...',
  ranking_filter_race: 'Irk',
  ranking_race_chinese: 'Chinese',
  ranking_race_euro: 'Euro',
  ranking_filter_mastery: 'Ustalık',
  ranking_mastery_bicheon: 'Bicheon',
  ranking_mastery_pacheon: 'Pacheon',
  ranking_mastery_heuksal: 'Heuksal',
  ranking_mastery_warrior: 'Savaşçı',
  ranking_mastery_rogue: 'Haydut',
  ranking_mastery_wizard: 'Büyücü',
  ranking_filter_reset: 'Sıfırla',
  ranking_filter_refresh: 'Sıralamayı yenile',
  ranking_col_character: 'Karakter',
  ranking_col_guild: 'Lonca Adı',
  ranking_col_points: 'Puanlar',
  ranking_no_results: 'Filtrenize uyan oyuncu yok.',
  ranking_empty: 'Sıralama verisi henüz mevcut değil. Daha sonra tekrar deneyin.',
  ranking_error: 'Sıralama yüklenemedi. Yeniden denemek için ↺ simgesine dokunun.',
  ranking_error_auth: 'Sıralama yüklenemedi. Yeniden denemek için ↺ simgesine dokunun.',
  ranking_player_title: 'Oyuncu Sıralaması',
  ranking_guild_title: 'Lonca Sıralaması',
  ranking_mastery_title: 'Ustalık Sıralaması',
  ranking_arena_title: 'Arena PVP Sıralaması',
  ranking_profile_loading: 'Karakter profili yükleniyor...',
  ranking_profile_error_title: 'Hata',
  ranking_profile_error_message: 'Karakter profili yüklenemedi.',
  ranking_profile_back: 'Sıralamaya Dön',
  ranking_profile_inventory: 'Envanter',
  ranking_profile_avatar: 'Avatar',
  ranking_profile_level: 'Sv.',
  ranking_profile_strength: 'Güç:',
  ranking_profile_intelligence: 'Zeka:',
  ranking_profile_guild: 'Lonca:',
  ranking_profile_no_guild: '<yok>',
  job_level: 'Seviye',
  job_daily_progress: 'Günlük iş ilerlemesi',
  job_claimed: 'Talep Edildi',
  job_completed: 'Tamamlandı',
  job_in_progress: 'Devam Ediyor',
  job_gold: 'Altın',
  job_min: 'dak',
  job_delivery_history: 'Bugünün Teslimat Geçmişi',
  job_route: 'Rota',
  job_gold_earned: 'Kazanılan Altın',
  job_delivery_time: 'Teslimat Süresi',
  job_delivery_hour: 'Teslimat Saati',
  job_no_deliveries_today: 'Bugün kayıtlı teslimat yok.',
  job_no_job_info: 'Karakteriniz için iş bilgisi mevcut değil.',
  job_login_required: 'İş ilerlemenizi görmek için giriş yapmalısınız.',
  job_hwid_error: 'Donanım bilgisi alınamadı.',
  job_level_error: 'İş seviyesi alınamadı.',
  job_no_configuration: 'Bu iş türü için yapılandırma mevcut değil.',
  job_merchant: 'Tüccar',
  job_thief: 'Hırsız',
  job_hunter: 'Avcı',
  job_unknown: 'Bilinmeyen',
  job_invalid_data: 'Geçersiz veri',
  job_already_claimed_today: 'Bugünün ödülünü zaten talep ettiniz.',
  job_complete_progress_first: 'Ödülü talep etmeden önce günlük ilerlemeyi tamamlamalısınız.',
  job_no_reward_for_level: 'Mevcut seviyeniz için ödül mevcut değil.',
  job_reward_claimed_success: 'Ödül başarıyla talep edildi.',
  job_success: 'Başarılı',
  job_error: 'Hata',
  job_network_error: 'Ağ hatası',
  job_protected_cargo: 'Korumalı Ticari Mal',
  job_stolen_cargo: 'Çalıntı Ticari Mal',
  cupon_title: 'Kuponlar',
  cupon_level_required: 'Seviye',
  cupon_rewards_title: 'Kupon Ödülleri',
  cupon_expires_in: 'Bitiş süresi',
  cupon_claim_button: 'Kuponu Talep Et',
  cupon_claimed_button: 'Talep Edildi',
  cupon_confirm_button: 'Onayla',
  cupon_resend_button: 'Kodu yeniden gönder',
  cupon_verification_title: 'Doğrulama kodunu girin',
  cupon_choose_channel: 'Where should we send your code?',
  cupon_contact_missing: 'Not configured',
  cupon_whatsapp_verify: 'Verified number required',
  cupon_configure_contact: 'Configure WhatsApp in Settings',
  cupon_sent_via: 'Code sent via {channel}',
  cupon_code_sent_info: 'E-posta adresinize bir doğrulama kodu gönderilecek',
  cupon_code_sent_button: 'Gönderildi - E-postanızı kontrol edin',
  cupon_coupon_claimed: 'Kupon başarıyla talep edildi! Oyundaki kasanızı kontrol edin.',
  cupon_no_coupons: 'Şu anda mevcut kupon yok',
  cupon_already_claimed: 'Bu kuponu zaten talep ettiniz',
  cupon_request_error: 'Kod istenirken hata. Tekrar deneyin.',
  cupon_complete_code: '6 haneli kodun tamamını girmelisiniz',
  cupon_processing_error: 'İstek işlenirken hata. Tekrar deneyin.',
  cupon_sending: 'Gönderiliyor...',
  cupon_processing: 'İşleniyor...',
  settings_tab_general: 'Genel',
  settings_tab_notifications: 'Bildirimler',
  settings_tab_restrictions: 'Kısıtlamalar',
  settings_label_language: 'Dil',
  settings_label_timezone: 'Saat Dilimi',
  settings_label_country: 'Ülke',
  settings_label_whatsapp: 'WhatsApp',
  settings_btn_verify: 'Doğrula',
  settings_btn_confirm: 'Onayla',
  settings_btn_save: 'Kaydet',
  settings_btn_validate_now: 'Şimdi Doğrula',
  settings_btn_validate_whatsapp: 'WhatsApp ile Doğrula',
  settings_btn_validate_authenticator: 'Authenticator ile Doğrula',
  settings_placeholder_code: 'Kod',
  settings_placeholder_phone: '1234567890',
  settings_no_events: 'Yapılandırılmış etkinlik yok',
  settings_minutes_before: 'dakika önce',
  settings_time_remaining: 'Bir sonraki gerekli doğrulamaya kadar kalan süre',
  settings_validation_warning: 'Doğrulamanız yakında sona erecek. Kesintisiz oynamaya devam etmek için şimdi yenileyin.',
  settings_validation_active: 'Bağlantınız doğrulandı ve aktif.',
  settings_validation_expired: 'Oyunda hareket edebilmek için bağlantınızı doğrulamanız gerekir.',
  settings_coming_soon: '(Yakında)',
  settings_no_hwid: 'HWID alınamadı. Lütfen oyuna giriş yapın.',
  settings_code_sent: 'Kod gönderildi. WhatsApp\'ınızı kontrol edin.',
  settings_whatsapp_verified_success: 'WhatsApp başarıyla doğrulandı',
  settings_error_update_config: 'Yapılandırma güncellenirken hata',
  settings_error_phone_required: 'Lütfen bir telefon numarası girin',
  settings_error_code_required: 'Lütfen geçerli bir 6 haneli kod girin',
  settings_error_send_code: 'Doğrulama kodu gönderilirken hata',
  settings_error_verify_code: 'Kod doğrulanırken hata',
  settings_error_validate_connection: 'Bağlantı doğrulanırken hata',
  settings_error_code_incorrect: 'Yanlış kod',
  settings_no_results: 'Sonuç bulunamadı',
  settings_searching: 'Aranıyor...',
  messages_page_title: 'Sohbet',
  messages_conversations: 'Konuşmalar',
  messages_new_chat: 'Yeni Sohbet',
  messages_search_player: 'Oyuncu ara...',
  messages_type_message: 'Mesaj yazın...',
  messages_send: 'Gönder',
  messages_attach_item: 'Eşya Ekle',
  messages_online: 'Çevrimiçi',
  messages_offline: 'Çevrimdışı',
  messages_no_messages: 'Henüz mesaj yok',
  messages_no_conversations: 'Konuşma yok',
  messages_loading: 'Yükleniyor...',
  messages_error_send: 'Mesaj gönderilirken hata',
  messages_error_load: 'Mesajlar yüklenirken hata',
  messages_retry: 'Tekrar Dene',
  messages_select_player: 'Sohbet başlatmak için bir oyuncu seçin',
  messages_select_item: 'Bir eşya seçin',
  messages_item_attached: 'Eşya eklendi',
  messages_remove_item: 'Eşyayı kaldır',
  messages_confirm: 'Onayla',
  messages_cancel: 'İptal',
  messages_today: 'Bugün',
  messages_yesterday: 'Dün',
  messages_typing: 'yazıyor...',
  messages_translate: 'Çevir',
  messages_show_original: 'Orijinali göster',
  messages_translate_error: 'Mesaj çevrilemedi',
  messages_scroll_for_more: 'Eski mesajlar için yukarı kaydırın',

  notifications_title: 'Bildirimler',
  notifications_no_notifications: 'Bildirim mevcut değil',
  notifications_no_type: 'Tür yok',
  notifications_published: 'Yayınlandı:',
  notifications_expires: 'Bitiş:',
  notifications_like: 'Beğen',
  notifications_dislike: 'Beğenme',
  notifications_back_to_notifications: 'Bildirimlere Dön',
  notifications_vote_error: 'Oy güncellenirken hata',
  notifications_loading: 'Yükleniyor...',
  notifications_error_load: 'Bildirimler yüklenirken hata',
  notifications_not_found: 'Bildirim bulunamadı veya mevcut değil',

  dt_title: 'Günlük Görevler',
  dt_global_progress: 'Genel İlerleme',
  dt_tasks_completed: 'görev tamamlandı',
  dt_no_tasks: 'Şu anda mevcut görev yok.',
  dt_claimed: 'Talep Edildi',
  dt_incomplete: 'Tamamlanmadı',
  dt_final_rewards: 'Final Ödülleri',
  dt_final_rewards_description:
    'Bu final ödüllerini açmak için tüm günlük görevleri tamamlayın ve tüm ödüllerini talep edin.',
  dt_claim_final_reward: 'Final Ödülü Talep Et',
  dt_complete_all_first: 'Önce tüm günlük görevleri tamamlamalı ve talep etmelisiniz',
  dt_success: 'Başarılı',
  dt_error: 'Hata',
  dt_network_error: 'Ağ hatası',
  dt_processing: 'İşleniyor...',
  dt_login_required: 'Günlük görevleri görmek için giriş yapmalısınız.',
  dt_load_error: 'Günlük görevler yüklenemedi.',

  don_package: 'Paket:',
  don_silks: 'Silk:',
  don_price: 'Fiyat:',
  don_silks_label: 'silk',
  don_vip_points: '{amount} VIP Puan',
  don_promo: 'Promo',
  don_special_offer: 'Özel Teklif',
  don_back: '← Geri',
  don_pay: 'Öde $',
  don_continue_paypal: "PayPal'a devam et",
  don_processing: 'İşleniyor...',
  don_binance_soon: 'Binance ödemesi yakında...',
  don_error_create: 'Ödeme oluşturulamadı',
  don_stripe_not_loaded: 'Stripe SDK yüklenmedi',
  don_success_processing: 'Ödeme işleniyor...',
  don_success_wait: 'Bağışınız onaylanırken lütfen bekleyin.',
  don_success_ok: 'Ödeme başarılı!',
  don_success_fail: 'Ödeme tamamlanmadı',
  don_success_fail_msg: 'Bağışınız onaylanamadı. Lütfen tekrar deneyin.',
  don_cancel_title: 'Ödeme iptal edildi',
  don_cancel_msg: 'Bağışınız tamamlanmadı. İstediğiniz zaman tekrar deneyebilirsiniz.',
  don_back_to: 'Bağışlara Dön',
  don_credited: 'Hesabınıza {amount} silk yatırıldı.',
  cal_claimed: 'Alındı',
  cal_locked: 'Kilitli',
  cal_today: 'Bugün',
  cal_claim: 'Al',
  cal_streak_label: 'Giriş yapılan gün',
  cal_consecutive_login: 'Ardışık giriş',
  cal_upcoming: 'Yaklaşan',
  cal_upcoming_rewards: 'Yaklaşan ödüller',
  cal_no_upcoming: 'Yaklaşan yok',
  cal_monthly_bonus: 'Aylık bonus',
  cal_monthly_bonus_desc: 'Aylık bonusu almak için {days} gün giriş yap.',
  cal_days_remaining: '{days} gün kaldı',
  cal_day_remaining: '1 gün kaldı',
  cal_info_title: 'Etkinlik bilgisi',
  cal_default_desc: 'Özel ödüller için her gün giriş yap. Bir gün kaçırdın mı? Devam et, İmparatorluk seni bekliyor.',
  cal_prev: 'Önceki',
  cal_next: 'Sonraki',
  cal_bonus_days_unit: 'gün',
  cal_bonus_n_day: '1 gün',
  cal_bonus_n_days: '{days} gün',
  cal_bonus_7_days: '7 gün',
  cal_bonus_15_days: '15 gün',
  cal_bonus_1_month: '1 ay',
  bp_multiple_items: 'Birden fazla eşya mevcut',
  vip_title: 'VIP Sistemi',
  vip_col_level: 'SEVİYE',
  vip_col_progress: 'İLERLEME',
  vip_col_rewards: 'ÖDÜLLER',
  vip_col_state: 'DURUM',
  vip_level_label: 'VIP Seviye ({level})',
  vip_state_unlocked: 'Unlocked',
  vip_no_levels: 'No VIP levels configured.',
  vip_points_rate: '{points} VIP Points.',
  vip_your_points: 'Your points',
  vip_current_level: 'Current level',
  vip_next_level: 'Next level',
  vip_all_unlocked: 'All levels unlocked',
  vip_points_remaining: '{points} points to go',
  vip_information: 'VIP information',
  vip_close: 'Close',
  vip_info_account: 'VIP points belong to your account. Only completed donations with credited VIP points count.',
  vip_info_unlock: 'Reach the required points to unlock each level. Your points accumulate and are not spent when a level unlocks.',
  vip_info_rewards: 'Unlocked means you meet the requirement. Reward claiming and delivery are not available yet.',
  vip_state_locked: 'Kilitli',
  vip_note: 'Bağışladığınız her $1 için',
  vip_note_points: '10 VIP Puan alırsınız.',
  don_history: "Satın alma geçmişi",
  don_history_loading: "Satın almalar yükleniyor...",
  don_history_error: "Satın alma geçmişi yüklenemedi.",
  don_history_empty: "Henüz satın alma yok.",
  don_history_date: "Tarih",
  don_history_method: "Yöntem",
  don_history_status: "Durum",
  don_history_previous: "Önceki",
  don_history_next: "Sonraki",
  don_status_completed: "Tamamlandı",
  don_status_pending: "Beklemede",
  don_status_cancelled: "İptal edildi",
  don_status_failed: "Başarısız",
  don_daily_limit: "Son 24 saatte {current} harcadınız. Bu {amount} tutarındaki alışveriş toplamı {total} yaparak {limit} sınırını aşar. Kullanabileceğiniz tutar: {remaining}.",
  don_limit_available: "Kullanılabilir: {amount}",
  don_reset_ready: "Son 24 saatteki ödemeler",
  don_reset_updating: "Limit yenileniyor...",
  don_reset_error: "Limit bilgisi alınamadı",
  don_reset_in: "Yenilenmeye {time}",
  don_limit_locked: "Ödeme sınırına ulaştınız. Yeniden ödeme yapmak için başlıktaki geri sayımın bitmesini bekleyin.",
} as const;

export default tr;
